<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">活動</div>
            <div class="breadcrumb-item">活動列表-新增</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>活動名稱</span>
                                        </div>
                                        <Input v-model="form.activity_name" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <span>活動備註</span>
                                        </div>
                                        <Input v-model="form.remark_info" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>是否開啓</span>
                                        </div>
                                        <Switchs true-color="#51f4a9" v-model="form.is_status" />
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">新增</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                isSubmiting: false,
                form: {
                    activity_name: '',
                    remark_info: '',
                    is_status: '',
                }
            };
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            handleCheckForm()
            {
                let form = this.form;

                if (form.activity_name === '')
                {
                    this.$Utils.showTipInfo('請輸入活動名稱');
                    return;
                } 
                this.handleSubmit();
            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.eventActivityAdd,
                    method: 'post',
                    data: {
                        activity_name: form.activity_name,
                        remark_info: form.remark_info,
                        is_status: Number(form.is_status),
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.form = {
                            activity_name: '',
                            remark_info: '',
                            is_status: '',
                        };
                        this.$Utils.showSuccess(res.msg);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "eventListAdd.scss";
</style>